<template lang="pug">
.register-row
  .register-group
    .register-key
      span.key-name 予約時間単位
      span.validation-label 必須

    .register-value.unit-radios
      label.register-radio-label
        input#type-0.register-radio-form(
          v-model="_value"
          :name="name"
          type="radio"
          :value="15"
          v-validate="{ required: true }"
          data-vv-as="予約時間単位")
        span.register-radio-text 15分
      label.register-radio-label
        input#type-1.register-radio-form(v-model="_value" :name="name" type="radio" :value="30")
        span.register-radio-text 30分
      label.register-radio-label
        input#type-2.register-radio-form(v-model="_value" :name="name" type="radio" :value="60")
        span.register-radio-text 1時間

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputUnit extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Number })
  value!: number;

  @Prop({ default: "unit" })
  name!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): number {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: number) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
// ラジオボタンは横幅に応じてラップする
.unit-radios {
  flex-wrap: wrap;
}
</style>
